export enum TargetFileFormingResultStatus {
  Success = 1,
  PartiallyGenerated = 2,
  Failure = 3,
  NoFiles = 4
}
